<div [ngClass]="ccssService.getClass('home')">
  <app-pcp-message></app-pcp-message>
  <app-disclaimers
    [disclaimers]="disclaimers"
    [container]="true"
  ></app-disclaimers>

  <div
    *ngIf="{ background: homeBackgroundColor | async } as d"
    class="home-container"
    data-cy="home-container"
    [ngClass]="[d.background]"
    [ngClass.lt-md]="['mobile', d.background]"
    appDelightedTrigger
    delightedSurveyType="nps"
    [delightedDelay]="300000"
    role="status"
    aria-atomic="true"
    [attr.aria-label]="'app_return_home_confirmation' | translate"
  >
    <platform-page-container [fullscreen]="false" [contentSpacing]="true">
      <div class="hero-wrapper flex justify-center">
        <div
          class="hero-container"
          fxLayout="column"
          fxFlex="68"
          fxFlex.lt-md="100"
        >
          <!-- Welcome -->
          <app-welcome-banner
            class="high-contrast-theme mt-2"
            [ngClass]="{ 'text-center': !breakpoints.isMobile }"
            [memberName]="member?.first_name"
          ></app-welcome-banner>

          <!-- Network, Location, Members Desktop -->
          <div *ngIf="!breakpoints.isMobile" class="mt-8 mb-6">
            <app-network-location-members
              [isMobile]="false"
              [authStatus]="auth.auth_status"
              [member]="member"
              [isHomePage]="true"
            ></app-network-location-members>
          </div>

          <!-- Autosuggest Desktop -->
          <div
            *ngIf="!breakpoints.isMobile && guidedSearchReady"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="24px"
          >
            <span class="global-autosuggest-container w-full">
              <app-global-header-autosuggest
                #autosuggest
                appLnp
                lnpComponentName="app-global-header-autosuggest"
                [preserveTerm]="false"
                [selectedGroup]="termAutosuggest.selectedGroup"
                (clearEvent)="termAutosuggest.clear()"
                [homepage]="true"
              >
              </app-global-header-autosuggest>
              <app-fixed-tooltip
                *ngIf="showUuxSearchAgainTooltip && !isInitialPageLoad"
                [hasLoadChangeClick]="true"
                [dontShowAgainBtn]="true"
                [dontShowAgainText]="
                  'uux_search_again_tooltip_dont_show' | translate
                "
                [title]="'uux_search_again_tooltip_title' | translate"
                [text]="'uux_search_again_tooltip_body' | translate"
                [showDismissButton]="true"
                (dismissClick)="onDismissSearchTooltipClicked(false)"
                [show]="showUuxSearchAgainTooltip"
                (dismissForSession)="onDismissSearchTooltipClicked(true)"
              >
              </app-fixed-tooltip>
              <div *ngIf="!!displayBillingSearch">
                <app-search-by-billing-link data-cy="search-by-billing-link">
                </app-search-by-billing-link>
              </div>
            </span>
          </div>

          <!-- Network, Location, Members Mobile -->
          <div *ngIf="breakpoints.isMobile" class="mt-4">
            <app-network-location-members
              [isMobile]="true"
              [authStatus]="auth.auth_status"
              [member]="member"
              [isHomePage]="true"
            ></app-network-location-members>
          </div>

          <!-- Autosuggest Mobile -->
          <div
            *ngIf="breakpoints.isMobile && guidedSearchReady"
            class="home-autosuggest margin top-3x"
            fxLayoutAlign="space-between center"
            fxLayoutGap="8px"
          >
            <span
              fxFlex="grow"
              class="global-autosuggest-container"
              data-cy="home-autosuggest.mobile"
            >
              <app-global-header-autosuggest
                #autosuggest
                appLnp
                lnpComponentName="app-global-header-autosuggest"
                [preserveTerm]="false"
                [selectedGroup]="termAutosuggest.selectedGroup"
                (clearEvent)="termAutosuggest.clear()"
                [homepage]="true"
              >
              </app-global-header-autosuggest>
              <div *ngIf="!!displayBillingSearch">
                <app-search-by-billing-link></app-search-by-billing-link>
              </div>
            </span>
          </div>

          <!-- Quick Links -->
          <app-quick-links class="high-contrast-theme mt-6"></app-quick-links>
        </div>
      </div>
    </platform-page-container>
  </div>

  <div class="primary-color-50">
    <app-guided-search-browse-by
      [authStatus]="auth.auth_status"
      (triggerRtsWelcomeOverlay)="triggerRtsWelcomeOverlay()"
    >
    </app-guided-search-browse-by>
  </div>

  <div class="sorted-modules" *ngIf="moduleSortOrder !== undefined">
    <app-content-messaging [style.order]="moduleSortOrder?.messaging">
    </app-content-messaging>

    <app-medication-finder-savings
      *ngIf="auth.auth_status && rx_savings_eligible"
    >
      [style.order]="moduleSortOrder?.medication_finder_savings">
    </app-medication-finder-savings>

    <app-rts-welcome-banner
      *ngIf="auth.auth_status && incentivesEnabled && rtsProcedures?.length > 0"
      [procedures]="rtsProcedures"
      [style.order]="moduleSortOrder?.rts_welcome_banner"
    >
    </app-rts-welcome-banner>

    <app-convenient-care [style.order]="moduleSortOrder?.convenient_care">
    </app-convenient-care>

    <app-promotional-procedures
      *ngIf="showPromotedProcedures()"
      [style.order]="moduleSortOrder?.promotional_procedures"
    >
    </app-promotional-procedures>

    <app-promotional-smartshopper
      *ngIf="showIncentivesFeature()"
      [style.order]="moduleSortOrder?.smart_shopper"
    >
    </app-promotional-smartshopper>

    <div
      *ngIf="telehealthSsoEnabled"
      class="margin bottom-6x"
      [style.order]="moduleSortOrder?.telehealth"
      data-cy="home-telehealth-module"
    >
      <h3 class="subhead text-medium" data-cy="home-telehealth-subheader">
        {{ 'telehealth_virtual_care' | translate }}
      </h3>
      <platform-page-container
        [fullscreen]="breakpoints.isMobile"
        [contentSpacing]="false"
      >
        <app-telehealth [displayAll]="true"></app-telehealth>
      </platform-page-container>
    </div>

    <app-promotional-benefits
      [hsa]="hsaEnabled"
      [pharmacy]="rxEnabled"
      (enabled)="benefitsEnabled = $event"
      [style.order]="moduleSortOrder?.hsa_benefits"
    >
    </app-promotional-benefits>

    <platform-page-container
      *ngIf="displayAncillaryLinks"
      [fullscreen]="false"
      [contentSpacing]="true"
      [style.order]="moduleSortOrder?.ancillary_links"
    >
      <app-ancillary-networks
        [ancillaryNetworks]="ancillaryNetworks"
        data-cy="home-ancillary-networks"
      >
      </app-ancillary-networks>
    </platform-page-container>

    <app-login-prompt
      *ngIf="!auth.auth_status && auth.url"
      [margin]="breakpoints.getBreakpoints('home').margin"
      [loginUrl]="auth.url"
      [style.order]="moduleSortOrder?.login"
    >
    </app-login-prompt>

    <app-external-links [style.order]="moduleSortOrder?.helpful_links">
    </app-external-links>

    <app-contact-us
      *ngIf="showCustomerServiceLayout"
      [style.order]="moduleSortOrder?.contact_us"
      data-cy="home-contact-us"
    >
    </app-contact-us>
  </div>

  <app-email-collection-tray
    *ngIf="showEmailTray()"
    appGtm
    [gtmOnShow]="true"
    [gtmData]="{ event: 'gtm.email_capture.load' }"
    [saveSuccess]="emailSaveSuccess"
    (closeTray)="closeEmailTray = true"
    (submitEmail)="saveEmail($event)"
  >
  </app-email-collection-tray>
</div>
